export enum COOKIES {
	ACCESS_TOKEN = 'ACCESS_TOKEN',
	REDIRECT_URL = 'REDIRECT_URL',
	UPDATE_CREDENTIALS_LINK_CLICKED = 'UPDATE_CREDENTIALS_LINK_CLICKED',
}
